import AssetsSpinner from '@jira/assets-app__spinner/src/SpinnerView.tsx';
import { assetsObjectTypeSettingsEntryPoint } from '@jira/spa-apps__servicedesk-cmdb-configure-object-type/src/assetsObjectTypeSettingsEntryPoint.entrypoint.tsx';
// eslint-disable-next-line jira/restricted/@jira+servicedesk__common-toPackageName
import { toPackageName, APP_NAMES } from '@jira/servicedesk__common/src/toPackageName.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { assetsObjectTypeConfigurationRoute } from '@jira/router-routes__assets-app-routes/src/assetsObjectTypeConfigurationRoute.tsx';
import { getAssetsAppResources } from '@jira/router-routes__servicedesk-cmdb-entries/src/common/getCmdbResources.tsx';
import { createChromelessEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import {
	LazyAssetsLayout,
	AssetsLayout,
} from '@jira/assets-app__layout/src/LayoutAssetsLayout.tsx';
import { AssetsPageConfigContainer } from '@jira/assets-app__page-config-container/src/AssetsPageConfigContainer.tsx';
import type { Route } from '@atlassian/react-resource-router';

const assetsObjectTypeSettingsPageEntryPoint = createChromelessEntryPoint({
	main: assetsObjectTypeSettingsEntryPoint,
});

export const assetsObjectTypeConfigurationRouteEntry: Route = createEntry(
	assetsObjectTypeConfigurationRoute,
	() => ({
		group: 'assets',
		LayoutOverrideComponent: AssetsLayout,
		PageConfigContainerOverride: AssetsPageConfigContainer,
		skeleton: AssetsSpinner,
		entryPoint: () => assetsObjectTypeSettingsPageEntryPoint,
		pageId: () => 'spa-apps/servicedesk/insight/cmdb-configure-object-type',
		resources: getAssetsAppResources(),
		forPaint: [LazyAssetsLayout],
		meta: {
			reporting: {
				id: APP_NAMES.INSIGHT_OBJECT_TYPE_CONFIGURATION,
				packageName: toPackageName(APP_NAMES.INSIGHT_OBJECT_TYPE_CONFIGURATION),
				teamName: 'astral',
			},
		},
		ufoName: 'service-management.insight-cmdb-object-type-configuration',
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
